import './show-on-scroll.scss';

export default (target, transition) => {
	target.classList.add(transition.startClass);

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				observer.disconnect();
				target.classList.remove(transition.startClass);
				target.classList.add(transition.endClass);
			}
		});
	}, {
		threshold: .5
	});

	observer.observe(target);
};

export const fadePanUp = {
	startClass: 'sos--fadepanup-start',
	endClass: 'sos--fadepanup-end'
};

export const fadePanRight = {
	startClass: 'sos--fadepanright-start',
	endClass: 'sos--fadepanright-end'
};